module.exports = __webpack_public_path__ + "img/bespoke123_08.0c5c4901.jpg";